import { useBranch } from "@/context/branch-context";
import { useMemo } from "react";

export const useBranchFilter = () => {
  const { selectedBranches } = useBranch();

  return useMemo(() => {
    const branchIds = selectedBranches
      .map((branch) => branch.bb_branch_id)
      .filter(Boolean);

    if (branchIds.length === 0) {
      return {};
    }

    if (branchIds.length === 1) {
      return { branch_id: branchIds[0] };
    }

    return { branch_id: { $in: branchIds } };
  }, [selectedBranches]);
};
